import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../../crystal-elements/cc-base.component";
import {RecapProfileService} from "../../../../../services/archive/recap-profile.service";
import {ReportProfile} from "../../../../../model/archive/report-profile";
import {FieldRecord} from "../../../../../model/api/field-record";
import {FieldRequest} from "../../../../../model/api/field-request";
import {CookieNames} from "../../../../../shared/cookie/cookie-names";
import {CcStorageService} from "../../../../../services/common/cc-storage.service";
import {StringUtils} from "../../../../../utils/stringUtils";

@Component({
  selector: 'app-archive-recap-list',
  templateUrl: './recap-list.component.html',
  styleUrls: ['./recap-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class RecapListComponent extends CcBaseComponent {

  profileTypes: FieldRecord<any>[] = [];

  records: any[] = [];
  favRecaps: string[] = [];
  displayedRecords: any[] = [];
  transPartKey: string = 'profile.recap.list';
  static readonly FAV_TAB_ID: string = '**FAV**';

  ExportFormat = ReportProfile.EXPORT_FORMAT;

  @Input()
  loading: boolean = true;
  @Output()
  loadingChange = new EventEmitter<boolean>();
  @Input()
  selectedRecords: any[] = [];
  @Output()
  selectedRecordsChange = new EventEmitter<any[]>();
  @Input()
  differential: boolean = true;
  @Output()
  differentialChange = new EventEmitter<boolean>();

  profileTypeItems: MenuItem[] = [];
  profileTypeActive: any = undefined;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              translateService: TranslateService,
              private storageService: CcStorageService,
              private recapProfileService: RecapProfileService) {
    super(cdref, messageService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    if (this.storageService.check(CookieNames.ARCHIVE_RECAP_FAV_LIST)) {
      this.favRecaps = JSON.parse(this.storageService.get(CookieNames.ARCHIVE_RECAP_FAV_LIST));
    }
  }

  protected initConfigs() {
    super.initConfigs();
    this.loading = true;
    this.recapProfileService.getProfileFieldsList(FieldRequest.DEFAULT()).subscribe(fieldResult => {

      this.profileTypes = fieldResult.recordTypes;
      this.profileTypes.sort((a, b) => (a.text || '').localeCompare(b.text || ''))
      this.profileTypeItems.splice(0);
      if (this.profileTypes.length > 0
        && fieldResult.records.some(value => !value.value.type)) {
        this.profileTypeItems.push({id: undefined, label: '______'});
      }
      this.profileTypes.forEach(value => this.profileTypeItems.push({id: value.id, label: value.text}));
      this.profileTypeItems = [...this.profileTypeItems];

      this.records = this.getFields(fieldResult).map(value => {
        return {
          title: value.value.title,
          name: value.value.name,
          exportFormat: value.value.exportFormat,
          type: value.value.type
        }
      });
      this.refreshFavTab();
      if (this.profileTypeItems.length > 0)
        this.profileTypeActive = this.profileTypeItems[0];
      else
        this.profileTypeActive = undefined;
      this.filterProfileType(this.profileTypeActive);
      setTimeout(() => {
        this.loading = false;
        this.markForCheck();
      });
      this.loadingChange.emit(false);
    });
  }

  filterProfileType(menuType: MenuItem) {
    this.profileTypeActive = menuType;
    if (this.profileTypeActive && this.profileTypeActive.id == RecapListComponent.FAV_TAB_ID) {
      this.displayedRecords = this.records.filter(value => this.favRecaps.includes(value.name));
    } else if (this.profileTypeActive) {
      this.displayedRecords = this.records.filter(value => this.profileTypeActive.id == value.type);
    } else {
      this.displayedRecords = this.records;
    }
  }

  refreshFavTab() {
    this.favRecaps = this.favRecaps.filter(fav => this.records.some(record => record.name === fav));
    this.storageService.set(CookieNames.ARCHIVE_RECAP_FAV_LIST, JSON.stringify(this.favRecaps));
    this.records.forEach(record => {
      record.isFavorite = this.favRecaps.includes(record.name);
    });
    if (this.favRecaps.length > 0) {
      if (!this.profileTypeItems.some(item => item.id == RecapListComponent.FAV_TAB_ID)) {
        this.profileTypeItems.unshift({
          id: RecapListComponent.FAV_TAB_ID,
          label: 'Favorites',
          icon: 'fa-solid fa-star'
        });
      }
      if (this.profileTypeActive && this.profileTypeActive.id == RecapListComponent.FAV_TAB_ID) {
        this.displayedRecords = this.records.filter(value => this.favRecaps.includes(value.name));
      }
    } else {
      this.profileTypeItems = this.profileTypeItems.filter(item => item.id !== RecapListComponent.FAV_TAB_ID);
      if (this.profileTypeActive) {
        this.profileTypeActive = this.profileTypeItems[0];
      }
      this.filterProfileType(this.profileTypeActive);
    }
    setTimeout(() => {
      this.profileTypeItems = [...this.profileTypeItems];
      this.markForCheck();
    });
  }

  addRemoveToFav(record: any, $event: MouseEvent) {
    $event.stopPropagation();
    if (!this.favRecaps.includes(record.name)) {
      this.favRecaps.push(record.name);
    } else {
      this.favRecaps = this.favRecaps.filter(value => value !== record.name);
    }
    this.refreshFavTab();
  }

  protected readonly StringUtils = StringUtils;
}
